import styles from './Spacer.module.scss'

const Spacer = ({className = ''}) => {
  return <div className={`${className} ${styles.spacer}`}></div>
}

export default Spacer
